export default __webpack_public_path__ + "static/media/Credencial_FUAR.0075cb46.gif";